import getCollectionData from "../../utils/getCollectionData";
import runTransaction from "../../utils/runTransaction";
import updateDocumentData from "../../utils/updateDocumentData";

import updateWork from "../works/updateWork";

import { Serie, SerieRef } from "./types/Serie";

export default async function updateSerie(firebase, { ref, name, description, updatedBy }) {
	const works = await getCollectionData(firebase.firestore().collection("works").where("serie.id", "==", ref.id));

	return runTransaction(firebase, [ref], async (transaction, [serie]) => {
		const data = Serie.partial().parse(updateDocumentData(firebase, { name, description, updatedBy }));

		transaction.update(serie.ref, data, { merge: true });

		const serieRef = SerieRef.parse({ ...serie, name, description });

		await Promise.all(
			works.map((work) => updateWork(firebase, { ref: work.ref, serie: serieRef }, { transaction })),
		);

		return { ...serie, ...data };
	});
}
